import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    IconButton,
    Avatar,
    Badge,
    Tooltip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { useEstilos } from '../../context/EstiloContext';
import ProfileMenu from './profileMenu';
import NotificationMenu from './notificationMenu';

const Header = ({ onToggleSidebar }) => {
    const { estilos } = useEstilos();
    const [anchorElProfile, setAnchorElProfile] = useState(null);
    const [anchorElNotification, setAnchorElNotification] = useState(null);

    const handleProfileClick = (event) => {
        setAnchorElProfile(event.currentTarget);
    };

    const handleNotificationClick = (event) => {
        setAnchorElNotification(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElProfile(null);
        setAnchorElNotification(null);
    };

    return (
        <AppBar
            position="fixed"
            elevation={1}
            sx={{
                backgroundColor: estilos.headerColor,
                color: estilos.textoColor,
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between', minHeight: 64 }}>
                {/* Logo e ícono menú */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton
                        edge="start"
                        onClick={onToggleSidebar}
                        sx={{
                            backgroundColor: '#f4f0ff',
                            color: '#7e3af2',
                            width: 36,
                            height: 36,
                            borderRadius: '8px'
                        }}
                    >
                        <MenuIcon fontSize="small" />
                    </IconButton>
                    {estilos.logoUrl ? (
                        <img src={estilos.logoUrl} alt="logo" style={{ height: 32 }} />
                    ) : (
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Mi Dashboard</Typography>
                    )}
                </Box>

                {/* Iconos lado derecho */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                    <Tooltip title="Notificaciones">
                        <IconButton
                            onClick={handleNotificationClick}
                            sx={{
                                backgroundColor: '#f4f0ff',
                                borderRadius: '8px',
                                width: 36,
                                height: 36,
                                color: '#7e3af2'
                            }}
                        >
                            <Badge badgeContent={1} color="error">
                                <NotificationsNoneRoundedIcon fontSize="small" />
                            </Badge>
                        </IconButton>
                    </Tooltip>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            padding: '2px 8px',
                            borderRadius: '18px',
                            backgroundColor: '#e6f4ff',
                            cursor: 'pointer'
                        }}
                        onClick={handleProfileClick}
                    >
                        <Avatar
                            alt="User"
                            src="/static/images/avatar/1.jpg"
                            sx={{ width: 28, height: 28 }}
                        />
                        <IconButton sx={{ padding: 0 }}>
                            <SettingsRoundedIcon sx={{ fontSize: 20, color: '#2196f3' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Toolbar>

            {/* Menús desplegables */}
            <ProfileMenu anchorEl={anchorElProfile} onClose={handleClose} />
            <NotificationMenu anchorEl={anchorElNotification} onClose={handleClose} />
        </AppBar>
    );
};

export default Header;
